import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatItem = _resolveComponent("FloatItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: "float-view",
    style: _normalizeStyle({ left: _ctx.layout.data.extra.width + 16 + 'px' })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floatData.list, (val, key) => {
      return (_openBlock(), _createBlock(_component_FloatItem, {
        key: val.id,
        data: val,
        index: key,
        onRemove: _ctx.onRemove
      }, null, 8, ["data", "index", "onRemove"]))
    }), 128))
  ], 4))
}